import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faGaugeHigh, faRightFromBracket, faXmark } from '@fortawesome/free-solid-svg-icons';
import Logo from 'assets/img/Logo_EPS_300.png';
import 'assets/styles/account.css';

export default function SideBarAdmin() {
    const [showSidebar, setShowSidebar] = useState(false);
    const user = useSelector((state) => state.userGlobal?.user || {});
    const closeNavigation = () => setShowSidebar(false);
    return (
        <>
            <button type="button" className="ae-sidebar-mobile-trigger" onClick={() => setShowSidebar(true)} aria-label="Ouvrir le menu"><FontAwesomeIcon icon={faBars} /></button>
            <div className={`ae-sidebar-backdrop${showSidebar ? ' is-visible' : ''}`} onClick={closeNavigation} aria-hidden="true" />
            <aside className={`ae-sidebar${showSidebar ? ' is-open' : ''}`}>
                <button type="button" className="ae-sidebar-close" onClick={closeNavigation} aria-label="Fermer le menu"><FontAwesomeIcon icon={faXmark} /></button>
                <NavLink to="/dashboard" className="ae-sidebar-logo" onClick={closeNavigation}><img src={Logo} alt="Accès EPS" /></NavLink>
                <nav className="ae-sidebar-nav" aria-label="Navigation administration">
                    {user.admin === true && <NavLink to="/dashboard" exact className="ae-sidebar-link" activeClassName="is-active" onClick={closeNavigation}><FontAwesomeIcon icon={faGaugeHigh} /><span>Dashboard</span></NavLink>}
                </nav>
                <div className="ae-sidebar-actions"><a className="ae-sidebar-action ae-sidebar-action--logout" href="/logout"><FontAwesomeIcon icon={faRightFromBracket} /><span>Déconnexion</span></a></div>
            </aside>
        </>
    );
}
